import Store from '../store/store'

export default class ItemViewManager {
	
	static itemView () {
        let currentPlaying = Store.state.playlistManager.getCurrentlyPlaying()
        let prevDuration = Store.state.playlistManager.audioManager.getCurrentTime()

		// if (currentPlaying && !this.paused()) {
        //     this.sendRequest(currentPlaying, prevDuration)
        // } else if (Store.state.playlistManager.prevPlaylist && Store.state.playlistManager.prevPlaylist.getCurrentlyPlaying()) {
        //     this.sendRequest(Store.state.playlistManager.prevPlaylist.getCurrentlyPlaying(), prevDuration)
        // }
	}

	static pause () {
		let currentPlaying = Store.state.playlistManager.getCurrentlyPlaying()
		if (currentPlaying) {
	        let duration = Store.state.playlistManager.audioManager.getCurrentTime()
			this.setItemView(currentPlaying.id, duration)
			//this.sendRequest(currentPlaying, Store.state.itemView.duration)
		}
	}

	static paused () {
		let currentPlaying = Store.state.playlistManager.getCurrentlyPlaying()
		if (currentPlaying) {
			let sentId = Store.state.itemView.id;
			return currentPlaying.id === sentId
		}

		return false;
	}

	static setItemView (id, duration) {
		Store.commit('setItemView', {id: id, duration: duration})
	}

	// static sendRequest (music, duration = null) {
    //     let payload = { beat_id: music.id }

    //     if (duration) {
    //         payload.duration = duration
    //     }
    // 	Store.state.app.$http.post(`${ab.siteUrl}/events/marketplace/item/view`, payload)
    // }
}
